import React from "react";
import { useTranslation } from "@helpers/translate";
import TradeArrowUpIcon from "@assets/icons/TradeArrowUpIcon";
import TradeArrowDownIcon from "@assets/icons/TradeArrowDownIcon";

/**
 * @param {object} props
 * @param {boolean} props.isLong
 * @param {(direction: 'long' | 'short') => void} props.onDirectionChange
 * @param {string} props.longColor
 * @param {string} props.shortColor
 * @param {string} props.mutedColor
 */
export const DirectionSwitch = ({
  isLong,
  onDirectionChange,
  longColor,
  shortColor,
  mutedColor,
}) => {
  const { __ } = useTranslation();

  return (
    <div className="trade-form__direction">
      <p className="trade-form__section-label">{__("futures.trade_details.direction")}</p>

      <div className="trade-form__segment" role="group" aria-label={__("futures.trade_details.direction")}>
        <button
          type="button"
          className={`trade-form__segment-btn${isLong ? " trade-form__segment-btn--active" : ""}`}
          aria-pressed={isLong}
          onClick={() => onDirectionChange("long")}
        >
          <TradeArrowUpIcon size={20} color={isLong ? longColor : mutedColor} />
          {__("futures.long")}
        </button>

        <button
          type="button"
          className={`trade-form__segment-btn${!isLong ? " trade-form__segment-btn--active" : ""}`}
          aria-pressed={!isLong}
          onClick={() => onDirectionChange("short")}
        >
          <TradeArrowDownIcon
            size={20}
            color={!isLong ? shortColor : mutedColor}
          />
          {__("futures.short")}
        </button>
      </div>
    </div>
  );
};
